/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_New_Error_Country_RequiredInputs */



/**
* | output |
* | --- |
* | "Country is required for in-person tournaments" |
*
* @param {Tournament_New_Error_Country_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_new_error_country_required = /** @type {((inputs?: Tournament_New_Error_Country_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_New_Error_Country_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le pays est requis pour les tournois en présentiel")
	if (locale === "es") return /** @type {LocalizedString} */ ("El país es obligatorio para torneos presenciales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O país é obrigatório para torneios presenciais")
	if (locale === "it") return /** @type {LocalizedString} */ ("La nazione è obbligatoria per i tornei in presenza")
	return /** @type {LocalizedString} */ ("Country is required for in-person tournaments")
});